import styled from '@emotion/styled'
import { css } from '@emotion/react'
import mq from 'theme/mediaQueries'

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1380px;
  padding: 0 20px 20px;
  column-gap: 20px;

  ${mq({
    display: ['block', 'block', 'grid'],
    gridTemplateColumns: ['0 100%', '0 100%', '250px auto'],
  })}
`

export const PaginationContainer = styled.div`
  padding: 20px;
  text-align: center;
`

export const TopContainer = styled.div`
  display: grid;
  grid-template-columns: 60% 40%;
  padding: 0 10px 5px;
`

export const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    margin-left: 15px;
  }
`

export const showSearch = css`
  max-height: 300px;
  opacity: 1;
  z-index: 11;
`

export const SearchForm = styled.div`
  max-height: 0;
  transition: max-height .3s ease-in-out;
  position: relative;
  z-index: 2;
`

export const SearchFormContent = styled.div`
  padding: 5px 15px;
  opacity: 0;
  transition: opacity .4s ease-in-out;
`

export const ListContainer = styled.div`
  background-color: #fff;
  position: relative;
  z-index: 10;
`
